var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentLogs1 = function SvgPaymentLogs1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.417.25C1.222.25.25 1.201.25 2.375v8.5C.25 12.047 1.222 13 2.417 13h15.166c1.197 0 2.167-.953 2.167-2.125v-8.5c0-1.174-.97-2.125-2.167-2.125zm13 10.625c0-1.172.97-2.125 2.166-2.125v2.125zM17.583 4.5c-1.196 0-2.166-.953-2.166-2.125h2.166zM2.417 10.875V8.75c1.195 0 2.166.953 2.166 2.125zm0-8.5h2.166c0 1.172-.971 2.125-2.166 2.125zM10 9.813c-1.794 0-3.25-1.428-3.25-3.188 0-1.79 1.456-3.187 3.25-3.187 1.825 0 3.25 1.397 3.25 3.187 0 1.76-1.425 3.188-3.25 3.188"
  })));
};
export default SvgPaymentLogs1;